/**
 * English (en) — base translation file
 * All keys use flat namespace.key format
 */
export const en: Record<string, string> = {
  // ── Menu Scenes ──────────────────────────────────────────
  'menu.play_game': 'PLAY GAME',
  'menu.version': 'v0.1.0 - PHASER MIGRATION',
  'menu.back_to_menu': 'BACK TO MENU',

  // ── Options ──────────────────────────────────────────────
  'options.title': 'OPTIONS',
  'options.graphics': 'GRAPHICS',
  'options.audio': 'AUDIO',
  'options.gameplay': 'GAMEPLAY',
  'options.language': 'LANGUAGE',
  'options.resolution': 'Resolution:',
  'options.quality': 'Quality:',
  'options.fullscreen': 'Fullscreen',
  'options.autosave': 'Auto-save',
  'options.show_tooltips': 'Show Tooltips',
  'options.master_volume': 'Master Volume',
  'options.music_volume': 'Music Volume',
  'options.sfx_volume': 'SFX Volume',
  'options.difficulty': 'Difficulty:',
  'options.select_language': 'Select Language',

  // ── Login ────────────────────────────────────────────────
  'login.brand_crimson': 'CRIMSON',
  'login.brand_mandate': 'MANDATE',
  'login.tagline': 'Mine\u2022Trade\u2022Conquer\u2022Earn USDC',
  'login.version': 'CRIMSON MANDATE v0.1.0',
  'login.enter_email': 'ENTER EMAIL',
  'login.email_placeholder': 'commander@fleet.com',
  'login.enter_password': 'ENTER PASSWORD',
  'login.password_placeholder': '\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022',
  'login.remember_me': 'REMEMBER ME',
  'login.conquer_galaxy': 'CONQUER THE GALAXY',
  'login.connecting': 'CONNECTING...',
  'login.forgot_password': 'FORGOT PASSWORD?',
  'login.create_account': 'CREATE ACCOUNT >',
  'login.password_reset_soon': 'Password reset coming soon',
  'login.shop_banner': 'You need an account to purchase a ship. Log in or create an account below.',
  'login.enter_email_password': 'Please enter email and password',
  'login.server_unavailable': 'Server unavailable. Please try again later.',
  'login.login_failed': 'Login failed',
  'login.connection_failed': 'Connection failed',
  'login.unknown_error': 'Unknown error',

  // ── Register ─────────────────────────────────────────────
  'register.commander_name': 'COMMANDER NAME',
  'register.username_placeholder': 'CaptainNova',
  'register.email_address': 'EMAIL ADDRESS',
  'register.password': 'PASSWORD',
  'register.confirm_password': 'CONFIRM PASSWORD',
  'register.create_commander': 'CREATE COMMANDER',
  'register.creating': 'CREATING...',
  'register.back_to_login': '< BACK TO LOGIN',
  'register.strength_length': '\u2298 8+ characters',
  'register.strength_number': '\u2298 Number',
  'register.strength_symbol': '\u2298 Symbol',
  'register.passwords_match': '\u2713 Passwords match',
  'register.passwords_no_match': '\u2717 Passwords do not match',
  'register.fill_all_fields': 'Please fill in all fields',
  'register.name_too_short': 'Commander name must be at least 3 characters',
  'register.password_too_short': 'Password must be at least 8 characters',
  'register.passwords_mismatch': 'Passwords do not match',
  'register.account_created_login': 'Account created! Logging in...',
  'register.account_created_connect': 'Account created! Connecting...',
  'register.connection_failed': 'Account created, but the connection to the game timed out. Try refreshing the page or logging in.',
  'register.registration_failed': 'Registration failed',

  // ── HUD Top Bar ──────────────────────────────────────────
  'hud.logo': 'CRIMSON\nMANDATE',
  'hud.menu': '\u2630 Menu',

  // ── Nav Buttons ──────────────────────────────────────────
  'nav.wreck': 'Wreck',
  'nav.insure': 'Insure',
  'nav.trade': 'Trade',
  'nav.ore': 'Ore',
  'nav.crew': 'Crew',
  'nav.parts': 'Parts',
  'nav.shop': 'Shop',
  'nav.buy_isd': 'Buy ISD',
  'nav.station': 'Station',
  'nav.center': 'Center',
  'nav.follow': 'Follow',
  'nav.research': 'Research',
  'nav.tech': 'Tech',
  'nav.alliance_hq': 'Alliance HQ',
  'nav.refund': 'Buy-Back',
  'nav.withdraw': 'Withdraw',

  // ── Disconnect Overlay ───────────────────────────────────
  'disconnect.title': 'CONNECTION LOST',
  'disconnect.idle': 'Disconnected due to inactivity.',
  'disconnect.reconnecting': 'Reconnecting... ({attempt}/{max})',
  'disconnect.failed': 'Reconnection failed.',
  'disconnect.reconnect': 'Reconnect',

  // ── Dialog Titles ────────────────────────────────────────
  'dialog.menu': 'MENU',
  'dialog.ship_store': 'SHIP STORE',
  'dialog.components': 'COMPONENTS',
  'dialog.ore_inventory': 'ORE INVENTORY',
  'dialog.wreckage': 'WRECKAGE',
  'dialog.insurance': 'INSURANCE',
  'dialog.stations': 'STATIONS',
  'dialog.crew_quarters': 'CREW QUARTERS',
  'dialog.trade_hub': 'TRADE HUB',
  'dialog.browse_alliances': 'BROWSE ALLIANCES',
  'dialog.alliance_hq': 'ALLIANCE HQ',
  'dialog.commander_profile': 'COMMANDER PROFILE',
  'dialog.refund': 'BUY-BACK',
  'dialog.relic_inventory': 'RELIC INVENTORY',
  'dialog.tech_database': 'TECHNOLOGY DATABASE',
  'dialog.buy_isd': 'BUY $ISD',
  'dialog.ship_modification': 'SHIP MODIFICATION',
  'dialog.while_away': 'WHILE YOU WERE AWAY',
  'dialog.research_board': 'PUBLIC RESEARCH BOARD',
  'dialog.component_enhancement': 'COMPONENT ENHANCEMENT',
  'dialog.alliance': 'ALLIANCE',
  'dialog.create_alliance': 'CREATE ALLIANCE',
  'dialog.alliance_management': 'Alliance Management',
  'dialog.direct_messages': 'DIRECT MESSAGES',
  'dialog.battle_report': 'BATTLE REPORT',
  'dialog.build_ship': 'BUILD SHIP \u2014 {planetName}',
  'dialog.pirate_faction': 'PIRATE FACTION',
  'dialog.player_profile': 'PLAYER PROFILE',
  'dialog.ship_details': 'SHIP DETAILS',
  'dialog.component_loadout': 'COMPONENT LOADOUT',
  'dialog.repair_component': 'REPAIR COMPONENT',

  // ── Resource Display ─────────────────────────────────────
  'resource.title': 'Resources',
  'resource.credits': 'ISD',
  'resource.minerals': 'Minerals',
  'resource.rare_metals': 'Rare Metals',
  'resource.tech_data': 'Tech Data',
  'resource.salvage': 'Salvage',
  'resource.exotic_matter': 'Exotic Matter',

  // ── Left Sidebar ─────────────────────────────────────────
  'sidebar.empire_status': 'Empire status',
  'sidebar.stations': 'STATIONS',
  'sidebar.ships': 'SHIPS',
  'sidebar.explored': 'EXPLORED',
  'sidebar.explored_hexes': '{count} Hexes',
  'sidebar.credit': 'CREDIT',
  'sidebar.fleet': 'FLEET',
  'sidebar.missions': 'MISSIONS',
  'sidebar.no_ships': 'No ships deployed',
  'sidebar.no_stations': 'No stations deployed',
  'sidebar.planet': 'Planet',
  'sidebar.station_label': 'Station',
  'sidebar.docked': 'Docked',
  'sidebar.docked_at': '\u2693 {location}',
  'sidebar.moving': 'Moving ({turns}t)',
  'sidebar.hp_percent': 'HP {pct}%',
  'sidebar.cargo': 'CARGO {used}/{cap}',
  'sidebar.no_missions': 'No missions\navailable',
  'sidebar.coming_soon': 'Coming soon',

  // ── Right Panel (Alliance) ───────────────────────────────
  'alliance.title': 'Alliance',
  'alliance.members': '{count} members',
  'alliance.online': '{count} online',
  'alliance.view': 'VIEW',
  'alliance.message': 'MESSAGE',
  'alliance.create': 'CREATE',
  'alliance.browse': 'BROWSE',

  // ── Chat Panel ───────────────────────────────────────────
  'chat.title': 'Communication',
  'chat.tab_chat': 'CHAT',
  'chat.tab_log': 'LOG',
  'chat.channel_alliance': 'ALLIANCE',
  'chat.channel_global': 'GLOBAL',
  'chat.placeholder': 'Type a message...',
  'chat.no_messages': 'No messages yet.\nType below to start chatting.',
  'chat.log_initialized': 'Activity log initialized',
  'chat.me': 'Me',

  // ── Command Dock ─────────────────────────────────────────
  // Action buttons
  'action.move': 'MOVE',
  'action.attack': 'ENGAGE',
  'action.dock': 'DOCK',
  'action.undock': 'UNDOCK',
  'action.mine': 'MINE',
  'action.stop': 'STOP',
  'action.repair': 'REPAIR',
  'action.modify': 'MODIFY',
  'action.goto': 'GOTO',
  'action.return': 'RETURN',
  'action.cancel': 'CANCEL',
  'action.rename': 'RENAME',
  'action.paint': 'PAINT',
  'action.sensor_boost': 'SENSOR+',
  'action.warp': 'WARP',
  'action.beacon': 'BEACON',
  'action.deliver': 'DELIVER',
  'action.pick_color': 'PICK COLOR',
  'action.select_ship_attack': 'SELECT SHIP TO ATTACK',
  'action.select_ship_move': 'SELECT SHIP TO MOVE',

  // Action tooltips
  'tooltip.move': 'Move your ship to a target hex',
  'tooltip.attack': 'Pursue and engage an enemy target',
  'tooltip.dock': 'Dock at a nearby planet or station for repairs',
  'tooltip.undock': 'Undock and choose where to fly',
  'tooltip.mine': 'Mine minerals from asteroid',
  'tooltip.stop_mine': 'Stop mining',
  'tooltip.repair': 'Repair hull using cargo minerals',
  'tooltip.repair_full': 'Unit is at full health',
  'tooltip.modify': 'Modify ship components at shipyard',
  'tooltip.modify_dock': 'Dock at a station to modify ship',
  'tooltip.goto': 'Navigate to specific coordinates',
  'tooltip.return_to_base': 'Return to nearest friendly station and auto-dock',
  'tooltip.mine_minerals': 'Mine minerals...',
  'tooltip.mine_stellar': 'Mine Tokens...',
  'tooltip.mine_move_adjacent': 'Move adjacent to an asteroid to mine',
  'tooltip.dock_no_target': 'Move within 1 hex of a planet or station to dock',
  'tooltip.dock_no_range': 'No planet or station within docking range',
  'tooltip.dock_disabled': 'Move within 1 hex of a planet or station to dock',
  'tooltip.undock_move': 'Undock and move to a target hex',
  'tooltip.repair_hull': 'Repair hull using cargo minerals',
  'tooltip.full_health': 'Unit is at full health',
  'tooltip.modify_components': 'Modify ship components at shipyard',
  'tooltip.dock_to_modify': 'Dock at a station to modify ship',

  // Stat tooltips (CommandDock uses these keys)
  'tooltip.speed': 'Base speed in hexes per tick',
  'tooltip.attack_stat': 'Base weapon damage dealt per combat tick',
  'tooltip.defense': 'Damage reduction from armor plating',
  'tooltip.range': 'Maximum weapon firing range in hexes',
  'tooltip.hull_integrity': 'Hull integrity \u2014 when this reaches 0 the ship is destroyed',
  'tooltip.shields_desc': 'Energy shields \u2014 absorbs damage before hull takes hits',

  // Ability tooltips (CommandDock uses these keys)
  'tooltip.sensor_sweep': '+3 vision range for 30 ticks',
  'tooltip.evasive_maneuvers': '+25% evasion for 20 ticks',
  'tooltip.afterburner': '2x movement speed for 25 ticks',
  'tooltip.missile_barrage': 'Fire all weapons (2x cooldowns)',
  'tooltip.broadside': '+25% damage (longer cooldowns)',
  'tooltip.shield_overcharge': '2x shield strength for 40 ticks',
  'tooltip.emergency_jump': 'Teleport 3 hexes instantly',

  // Asteroid stat tooltips (CommandDock uses these keys)
  'tooltip.richness': 'Mineral density \u2014 higher richness yields more resources per mining tick',
  'tooltip.remaining_ore': 'How much ore is left to mine from this asteroid',
  'tooltip.rarity': 'How rare this asteroid is \u2014 rarer asteroids contain more valuable minerals',
  'tooltip.asteroid_stellar': 'This asteroid yields crypto tokens when mined',
  'tooltip.asteroid_no_stellar': 'Only Cryptoids contain tokens',

  // Planet/Station tooltips
  'tooltip.planet_structural': 'Planet structural integrity and shields',
  'tooltip.station_structural': 'Station structural integrity and shields',
  'tooltip.mineral_storage': 'Mineral storage capacity',
  'tooltip.docked_planet': 'Ships currently docked at this planet',
  'tooltip.docked_station': 'Ships currently docked at this station',
  'tooltip.fee_earth': 'Fee for unloading at Earth',
  'tooltip.fee_station': 'Fee charged when asteroids are delivered through this station',
  'tooltip.planet_status': 'Planet operational status',
  'tooltip.station_status': 'Station operational status',

  // Stat labels
  'stat.health': 'HEALTH',
  'stat.shields': 'SHIELDS',
  'stat.speed': 'SPEED',
  'stat.attack': 'ATTACK',
  'stat.defense': 'DEFENSE',
  'stat.range': 'RANGE',
  'stat.storage': 'STORAGE',
  'stat.docked': 'DOCKED',
  'stat.fee': 'FEE',
  'stat.status': 'STATUS',
  'stat.active': 'ACTIVE',

  // Stat tooltips
  'stat_tip.health': 'Current hull integrity',
  'stat_tip.shields': 'Energy shield strength',
  'stat_tip.movement': 'Hexes moved per turn',
  'stat_tip.attack': 'Weapon damage output',
  'stat_tip.defense': 'Damage mitigation',
  'stat_tip.range': 'Maximum weapon range',

  // Abilities
  'ability.scan': 'SCAN',
  'ability.evade': 'EVADE',
  'ability.boost': 'BOOST',
  'ability.volley': 'VOLLEY',
  'ability.broad': 'BROAD',
  'ability.shield': 'SHIELD',
  'ability.jump': 'JUMP',
  'ability.none': 'No abilities',

  'ability_tip.scan': 'Scan surrounding area',
  'ability_tip.evade': 'Enter evasive flight mode',
  'ability_tip.boost': 'Boost engine speed',
  'ability_tip.volley': 'Fire all weapons simultaneously',
  'ability_tip.broad': 'Fire broadside cannons',
  'ability_tip.shield': 'Overcharge shield generator',
  'ability_tip.jump': 'Initiate warp jump',

  // Tabs (ship)
  'tab.actions': 'ACTIONS',
  'tab.abilities': 'ABILITIES',
  'tab.cargo': 'CARGO {used}/{cap}',
  'tab.crew': 'CREW',
  'tab.upgrades': 'UPGRADES',

  // Tabs (planet)
  'tab.storage': 'STORAGE',
  'tab.stellar': 'TOKENS',
  'tab.build': 'BUILD',

  // Tabs (station)
  'tab.manage': 'MANAGE',

  // Cargo
  'cargo.full_tooltip': 'Cargo full! Dock at a planet or station to deposit.',
  'cargo.loading': 'Loading cargo...',
  'cargo.empty': 'Cargo hold is empty',

  // Storage
  'storage.loading': 'Loading inventory...',
  'storage.empty': 'No minerals stored',
  'storage.stellar_stored': 'Tokens Stored',
  'storage.label': 'STORAGE',
  'storage.buy_ship': 'BUY SHIP',
  'storage.buy_parts': 'BUY PARTS',
  'storage.buy_crew': 'BUY CREW',

  // Asteroid
  'asteroid.richness': 'RICHNESS',
  'asteroid.rarity': 'RARITY',
  'asteroid.stellar': 'TOKENS',
  'asteroid.composition': 'COMPOSITION',
  'asteroid.no_mineral_data': 'No mineral data',
  'asteroid.suffix': ' Asteroid',
  'asteroid.remaining_ore': 'REMAINING ORE',
  'asteroid.stellar_label': 'TOKENS',
  'asteroid.legendary': 'Legendary',
  'asteroid.very_rich': 'Very Rich',
  'asteroid.rich': 'Rich',
  'asteroid.moderate': 'Moderate',
  'asteroid.poor': 'Poor',

  // Richness tiers
  'richness.legendary': 'Legendary',
  'richness.very_rich': 'Very Rich',
  'richness.rich': 'Rich',
  'richness.moderate': 'Moderate',
  'richness.poor': 'Poor',

  // Rarity tiers
  'rarity.legendary': 'Legendary',
  'rarity.epic': 'Epic',
  'rarity.rare': 'Rare',
  'rarity.uncommon': 'Uncommon',
  'rarity.common': 'Common',

  // Asteroid richness tooltips
  'asteroid_tip.richness': 'Mineral concentration quality',
  'asteroid_tip.rarity': 'How uncommon this asteroid is',
  'asteroid_tip.stellar': 'Token yield when towed to Earth',

  // Asteroid variant names
  'asteroid_variant.gold': 'Crypto',
  'asteroid_variant.platinum': 'Platinum',
  'asteroid_variant.dark_matter': 'Dark Matter',

  // Minerals
  'mineral.iron': 'Iron',
  'mineral.copper': 'Copper',
  'mineral.titanium': 'Titanium',
  'mineral.platinum': 'Platinum',
  'mineral.rhodium': 'Rhodium',
  'mineral.palladium': 'Palladium',
  'mineral.iridium': 'Iridium',
  'mineral.dark_matter': 'Dark Matter',
  'mineral.rare': 'Rare',
  'mineral.common': 'Common',
  'mineral.epic': 'Epic',
  'mineral.uncommon': 'Uncommon',

  // Wreck
  'wreck.suffix': ' Wreck',
  'wreck.time_left': 'TIME LEFT (hrs)',
  'wreck.type': 'TYPE',
  'wreck.tow': 'TOW',
  'wreck.repair_label': 'REPAIR',
  'wreck.repair': 'REPAIR',
  'wreck.your_wreck': 'YOUR WRECK',
  'wreck.manage': 'MANAGE',
  'wreck.being_towed': 'BEING TOWED',
  'wreck.being_repaired': 'BEING REPAIRED',
  'wreck.claimed': 'CLAIMED',
  'wreck.claim': 'CLAIM',

  // Enemy / Unit
  'unit.you': '(YOU)',
  'unit.enemy': 'ENEMY',
  'enemy.badge': 'ENEMY',
  'unit.loading': 'Loading...',
  'unit.no_ships': 'You have no ships',
  'unit.select_attack': 'SELECT SHIP TO ATTACK',
  'unit.select_move': 'SELECT SHIP TO MOVE',

  // Enemy actions
  'enemy.player': 'PLAYER',
  'enemy.ship': 'SHIP',
  'enemy.message': 'MESSAGE',
  'enemy.move_to': 'MOVE TO',

  // Planet
  'planet.home': '\u2605 HOME',
  'planet.neutral': 'NEUTRAL',
  'planet.your_planet': 'YOUR PLANET',
  'planet.docked': 'DOCKED',
  'planet.fee': 'FEE',
  'planet.status': 'STATUS',
  'planet.active': 'ACTIVE',
  'planet.nothing_producing': 'Nothing in production',
  'planet.no_production': 'No production',
  'planet.done': 'DONE',
  'planet.in_progress': 'IN PROGRESS',
  'planet.more_queued': '+{n} more queued',
  'planet.produce_ship': 'PRODUCE SHIP',
  'planet.produce_ship_tooltip': 'Build a new ship at this planet',

  // Station
  'station.waypoint': 'Waypoint',
  'station.depot': 'Depot',
  'station.fortress': 'Fortress',
  'station.capital': 'Capital',
  'station.your_station': 'YOUR STATION',
  'station.stored_asteroids': 'Stored Asteroids',
  'station.docking_fee': 'Docking Fee',
  'station.manage_station': 'MANAGE STATION',
  'station.manage_tooltip': 'Open station management panel',
  'station.produce_tooltip': 'Build a new ship at this station',
  'station.enemy': 'ENEMY',
  'station.nothing_producing': 'Nothing in production',
  'station.no_production': 'No production',
  'station.done': 'DONE',
  'station.in_progress': 'IN PROGRESS',
  'station.produce_ship': 'PRODUCE SHIP',

  // Upgrades / Burn sinks
  'upgrade.rename': 'Rename',
  'upgrade.rename_prompt': 'Enter new ship name (max 20 characters):',
  'upgrade.rename_tooltip': 'Give your ship a unique name (100 ISD)',
  'upgrade.paint': 'Paint',
  'upgrade.paint_tooltip': 'Change ship color (100 ISD)',
  'upgrade.sensor': 'Sensor+',
  'upgrade.sensor_tooltip': 'Extend sensor range by 1 hex (500 ISD)',
  'upgrade.warp': 'Warp',
  'upgrade.warp_soon': 'Warp jump: hex selection coming soon',
  'upgrade.warp_tooltip': 'Unlock warp jump ability (2000 ISD)',
  'upgrade.beacon': 'Beacon',
  'upgrade.beacon_no_alliance': 'You must be in an alliance to place beacons',
  'upgrade.beacon_tooltip': 'Place fleet beacon at your location (200 ISD)',
  'upgrade.deliver': 'Priority',
  'upgrade.deliver_tooltip': 'Mark delivery priority for towing (300 ISD)',
  'upgrade.pick_color': 'PICK COLOR',

  // Paint colors
  'color.red': 'Red',
  'color.green': 'Green',
  'color.blue': 'Blue',
  'color.yellow': 'Yellow',
  'color.pink': 'Pink',
  'color.cyan': 'Cyan',
  'color.orange': 'Orange',
  'color.white': 'White',

  // GOTO popup
  'goto.q': 'Q',
  'goto.r': 'R',
  'goto.go': 'GO',

  // Ship types
  'ship.scout': 'Scout',
  'ship.fighter': 'Fighter',
  'ship.destroyer': 'Destroyer',
  'ship.bomber': 'Bomber',
  'ship.trade_ship': 'Trade Ship',
  'ship.cruiser': 'Cruiser',
  'ship.carrier': 'Carrier',
  'ship.battleship': 'Battleship',
  'ship.dreadnought': 'Dreadnought',
  'ship.titan': 'Titan',
  'ship.space_tug': 'Space Tug',
  'ship.alien_leviathan': 'Alien Leviathan',

  // Ship roles
  'role.recon': 'Recon',
  'role.light_combat': 'Light Combat',
  'role.strike': 'Strike',
  'role.heavy_strike': 'Heavy Strike',
  'role.logistics': 'Logistics',
  'role.heavy_combat': 'Heavy Combat',
  'role.fleet_support': 'Fleet Support',
  'role.assault': 'Assault',
  'role.capital': 'Capital',
  'role.flagship': 'Flagship',

  // Ship store
  'store.credits': 'ISD: {n}',
  'store.buy_ship': 'BUY SHIP',
  'store.buy_parts': 'BUY PARTS',
  'store.buy_crew': 'BUY CREW',
  'store.loading_prices': 'Loading ship prices...',
  'store.load_failed': 'Failed to load prices. Try again later.',

  // Component categories
  'comp.all': 'ALL',
  'comp.weap': 'WEAP',
  'comp.eng': 'ENG',
  'comp.shld': 'SHLD',
  'comp.armr': 'ARMR',
  'comp.snsr': 'SNSR',
  'comp.rctr': 'RCTR',
  'comp.spec': 'SPEC',

  // Component tiers
  'tier.mk1': 'Mk I',
  'tier.mk2': 'Mk II',
  'tier.mk3': 'Mk III',
  'tier.mk4': 'Mk IV',
  'tier.proto': 'Proto',
  'tier.basic': 'Basic',
  'tier.improved': 'Improved',
  'tier.advanced': 'Advanced',
  'tier.elite': 'Elite',
  'tier.experimental': 'Experimental',

  // Component stats
  'comp_stat.hull_hp': 'Hull HP',
  'comp_stat.shields': 'Shields',
  'comp_stat.armor': 'Armor',
  'comp_stat.speed': 'Speed',
  'comp_stat.evasion': 'Evasion',
  'comp_stat.sensor_range': 'Sensor Range',
  'comp_stat.accuracy': 'Accuracy',
  'comp_stat.attack': 'Attack',
  'comp_stat.defense': 'Defense',
  'comp_stat.power_output': 'Power Output',
  'comp_stat.cooldown_reduc': 'Cooldown Reduc.',
  'comp_stat.shield_regen': 'Shield Regen',
  'comp_stat.damage': 'Damage',
  'comp_stat.fire_rate': 'Fire Rate',

  // Hamburger menu
  'hamburger.audio': 'AUDIO',
  'hamburger.master': 'Master',
  'hamburger.music': 'Music',

  // Tutorial hint panel
  'tutorial.dismiss': 'X',
  'tutorial.skip': 'Skip',

  // Number formatting
  'format.millions': 'M',
  'format.thousands': 'K',

  // FTUE hints (from server, but client can also use for display)
  'ftue.brand_new': 'Welcome, Commander! Click on your Scout ship to select it.',
  'ftue.first_select': 'Good! Now right-click a nearby hex to move your Scout.',
  'ftue.first_move': "You're moving! Explore the map \u2014 dark hexes are undiscovered.",
  'ftue.explore_vision': 'Find an asteroid and click Mine to gather minerals.',
  'ftue.first_mine': 'Great mining! Dock at Earth to unload your cargo.',
  'ftue.first_dock': 'Try opening the Ship Store to see available ships.',
  'ftue.understand_hud': 'Use the top bar buttons to buy ships, trade, and more!',
  'ftue.first_purchase': "You're ready to conquer the stars! Tutorial complete.",

  // Welcome asteroid
  'ftue.welcome_asteroid': 'A Welcome Gift asteroid appeared nearby! Mine it to claim your reward.',
  'asteroid.welcome_gift': 'Welcome Gift',
  'notification.welcome_claimed': 'Welcome reward claimed!',

  // ── How To Guide ──────────────────────────────────────────
  'howto.title': 'HOW TO PLAY',
  'howto.skip': 'Skip',
  'howto.next': 'Next',
  'howto.back': 'Back',
  'howto.done': 'Done',
  'howto.launch': 'Launch \u25B6',

  'howto.page1_title': 'Welcome, Commander',
  'howto.page1_bullet1': 'Your fleet. Your territory. A persistent galaxy where every action leaves a mark.',
  'howto.page1_bullet2': 'Build warships, miners, and scouts. Stake your claim among the stars.',

  'howto.page2_title': 'Explore the Unknown',
  'howto.page2_bullet1': 'Move to a hex to explore. Sensors reveal nearby space \u2014 the rest is darkness.',
  'howto.page2_bullet2': 'Safer near Earth. Richer (and deadlier) further out.',

  'howto.page3_title': 'Build Your Empire',
  'howto.page3_bullet1': 'Mine asteroids for resources \u2014 iron, platinum, even dark matter.',
  'howto.page3_bullet2': 'Dock at a station to unload, repair, and upgrade your fleet.',

  'howto.page4_title': 'Take What\u2019s Theirs',
  'howto.page4_bullet1': 'Attack rivals, salvage wrecks, and take the loot.',
  'howto.page4_bullet2': 'Raid enemy stations and dominate trade lanes.',

  'howto.page5_title': 'Play Your Way',
  'howto.page5_bullet1': 'Join an Alliance to share research, territory, and power \u2014 or answer to no one.',
  'howto.page5_bullet2': 'Go solo as a miner, pirate, tycoon, or fleet commander. Your call.',

  'howto.page6_title': 'The Unknown Awaits',
  'howto.page6_bullet1': 'Discover alien relics, Cryptoids, and Leviathans in deep space.',
  'howto.page6_bullet2': 'The galaxy is vast. How you conquer it is up to you.',

  'nav.how_to': 'How To',
  'dialog.how_to': 'HOW TO PLAY',

  // Orbital Platforms
  'platform.basic': 'Basic Platform',
  'platform.advanced': 'Advanced Platform',
  'platform.elite': 'Elite Platform',
  'platform.legendary': 'Legendary Platform',
  'platform.deploy': 'Deploy Platform',
  'platform.relocate': 'Relocate Platform',
  'platform.manage': 'Manage Platforms',
  'platform.purchase': 'Purchase Platform',
  'platform.mining_yield': 'Orbital Mining Yield',
  'platform.storage': 'Platform Storage',
  'platform.capabilities': 'Capabilities',
  'platform.dock': 'Docking Bay',
  'platform.repair': 'Repair Bay',
  'platform.shipyard': 'Shipyard',
  'platform.build': 'Unit Building',
  'platform.mining': 'Orbital Mining',
  'platform.earth_station': 'Earth Orbital Station',
  'platform.public': 'Public Platform',
  'planet.resources': 'Planet Resources',
  'planet.depleted': 'Depleted',
  'planet.remaining': 'Remaining',
  'commanddock.dock_platform': 'Dock at Platform',

  // ── Mineral Inventory Dialog ──────────────────────────────
  'ore.browse_trade': 'Browse Trade Hub',
  'ore.total_mined': 'Total Mined',
  'ore.base_value': 'Base Value',
  'ore.market_data': 'MARKET DATA',
  'ore.lowest': 'Lowest',
  'ore.average': 'Average',
  'ore.highest': 'Highest',
  'ore.active_listings': 'Active Listings',
  'ore.no_listings': 'No active listings',
  'ore.sell': 'Sell',
  'ore.select_location': 'Select a location to view its minerals',
  'ore.total_minerals': 'Total Minerals',
  'ore.mineral_types': 'Mineral Types',
  'ore.stored_minerals': 'STORED MINERALS',
  'ore.est_value': 'Est. Value (base)',
  'ore.in_inventory': 'In Inventory',
  'ore.tab_all': 'All',
  'ore.tab_by_location': 'By Location',

  // ── Alliance HQ Dialog ────────────────────────────────────
  'alliance_hq.outpost': 'Outpost',
  'alliance_hq.station': 'Station',
  'alliance_hq.fortress': 'Fortress',
  'alliance_hq.citadel': 'Citadel',
  'alliance_hq.equal_split': 'Equal Split',
  'alliance_hq.rank_weighted': 'Rank Weighted',
  'alliance_hq.activity_weighted': 'Activity Weighted',
  'alliance_hq.custom': 'Custom',

  // ── Station Management Dialog ─────────────────────────────
  'station_mgmt.basic_desc': 'Basic supply point. Low storage, low cost.',
  'station_mgmt.mid_desc': 'Mid-tier logistics hub. Expanded storage capacity.',
  'station_mgmt.fort_desc': 'Heavily fortified outpost with strong defenses.',
  'station_mgmt.capital_desc': 'Massive command station. Maximum storage and presence.',
  'station_mgmt.hp': 'HP',
  'station_mgmt.storage': 'Storage',
  'station_mgmt.owned_stations': 'OWNED STATIONS',
  'station_mgmt.no_stations': 'No stations owned yet',
  'station_mgmt.get_started': 'Purchase a station above to get started',

  // ── Wreckage Dialog — time formatting ────────────────────
  'time.days': 'd',
  'time.hours': 'h',
  'time.minutes': 'm',
  'time.expired': 'Expired',

  // Crew tab
  'crew.loading': 'Loading crew...',
  'crew.none_assigned': 'No crew assigned',
  'crew.skill_combat': 'Combat',
  'crew.skill_piloting': 'Piloting',
  'crew.skill_navigation': 'Navigation',
  'crew.skill_engineering': 'Engineering',
  'crew.skill_science': 'Science',

  // ── Leaderboard ────────────────────────────────────────────
  'nav.leaderboard': 'Leaderboard',
  'dialog.leaderboard': 'ALLIANCE LEADERBOARD',
  'leaderboard.rank': 'Rank',
  'leaderboard.alliance': 'Alliance',
  'leaderboard.prestige': 'Prestige',
  'leaderboard.territory': 'Territory',
  'leaderboard.members': 'Members',
  'leaderboard.hq_tier': 'HQ Tier',
  'leaderboard.no_data': 'No alliance data available.',
  'leaderboard.refresh': 'Refresh',
};
